<!-- Global Alerts Layout (Error & Success Floating Notifications Container) -->
<div class="position-fixed top-0 end-0 p-3 z-3 d-flex flex-column gap-2" style="max-width: 350px">
    @if (errorMessage()) {
    <div class="alert alert-danger alert-dismissible shadow border-danger border-opacity-25 fade show d-flex align-items-center gap-2 m-0 font-monospace py-2.5"
        role="alert">
        <i class="bi bi-exclamation-triangle-fill flex-shrink-0 text-danger fs-5"></i>
        <div class="small lh-sm flex-grow-1 pe-2"><strong>Execution Error:</strong> {{ errorMessage() }}</div>
        <button type="button" class="btn-close shadow-none top-50 translate-middle-y my-0 end-0 me-2"
            aria-label="Close"></button>
    </div>
    } @if (successMessage()) {
    <div class="alert alert-success alert-dismissible shadow border-success border-opacity-25 fade show d-flex align-items-center gap-2 m-0 font-monospace py-2.5"
        role="alert">
        <i class="bi bi-check-circle-fill flex-shrink-0 text-success fs-5"></i>
        <div class="small lh-sm flex-grow-1 pe-2">{{ successMessage() }}</div>
        <button type="button" class="btn-close shadow-none top-50 translate-middle-y my-0 end-0 me-2"
            aria-label="Close"></button>
    </div>
    }
</div>

<header class="d-flex flex-wrap align-items-center justify-content-between gap-3 p-3 border shadow-sm bg-body-tertiary">
    <div class="d-flex align-items-center gap-2">
        <button type="button"
            class="btn btn-sm btn-primary d-inline-flex align-items-center gap-1.5 px-3 py-2 shadow-sm fw-semibold"
            data-bs-toggle="modal" data-bs-target="#addNewCourse">
            <i class="fa-solid fa-plus font-xs"></i>
            <span>Add New Course</span>
        </button>
    </div>

    <div>
        <button type="button"
            class="btn btn-sm btn-outline-secondary fw-semibold shadow-sm d-inline-flex align-items-center gap-1.5 text-body"
            (click)="goToCatalogList()">
            <i class="bi bi-list"></i> Catalog List
        </button>
    </div>
</header>

<!-- Responsive Table Outer Box -->
<div class="table-responsive m-0">
    <table class="table table-hover align-middle mb-0 transition-base">
        <!-- Table Header Structure -->
        <thead class="table-light border-bottom font-monospace small text-uppercase tracking-wider text-body-secondary">
            <tr>
                <th class="ps-4 py-3">No</th>
                <th class="py-3">Course Name</th>
                <th class="py-3">Points</th>
                <th class="py-3">Catalog Name</th>
                <th class="py-3">Image Name</th>
                <th class="py-3">Redirect Url</th>
                <th class="py-3">Description</th>
                <th class="py-3 text-center">Status</th>
                <th class="py-3"></th>
            </tr>
        </thead>

        <!-- Table Body Container -->
        <tbody class="small text-body">
            @for (course of courseItemList() | paginate : { itemsPerPage: pageSize(), currentPage: page(), totalItems:
            allTotal() }; track course.courseName) {

            <tr class="transition-base">
                <!-- Serial Number -->
                <td class="ps-4 font-monospace fw-semibold">{{ course.srNo }}</td>
                <td class="fw-bold text-body">{{ course.name }}</td>
                <td class="fw-bold text-body">{{ course.points }}</td>
                <td class="fw-bold text-body">{{ course.catalogName }}</td>
                <td class="fw-bold text-body">{{ course.imageName }}</td>
                <td class="fw-bold text-body">{{ course.redirectUrl }}</td>
                <td class="fw-bold text-body">{{ course.description }}</td>
                <td class="text-center">
                    <div class="d-inline-flex align-items-center gap-2">
                        <span
                            class="badge font-monospace px-2.5 py-1.5 rounded-pill border fw-bold tracking-wider align-middle d-inline-flex align-items-center gap-1 min-w-75 transition-base"
                            [ngClass]="course.enabled ? 'bg-success-subtle text-success-emphasis border-success-subtle' : 'bg-danger-subtle text-danger-emphasis border-danger-subtle'">
                            <i [class]="course.enabled ? 'bi bi-check-circle-fill' : 'bi bi-x-circle-fill'"></i>
                            {{ course.enabled ? 'Active' : 'Disabled' }}
                        </span>

                        <!-- Custom CSS Custom Toggle iOS-style Switch Matrix Layout -->
                        <div class="form-check form-switch custom-ios-switch m-0 p-0">
                            <input class="form-check-input" type="checkbox" role="switch" [checked]="course.enabled"
                                [disabled]="apiLoading()" (change)="toggleCatalogStatus(course)" />
                        </div>
                    </div>
                </td>
                <td class="pe-4 text-end">
                    <div class="d-inline-flex gap-1">
                        <!-- Update Action Button -->
                        <button type="button"
                            class="btn btn-sm btn-outline-secondary border-0 p-1.5 rounded-2 d-inline-flex align-items-center justify-content-center text-body-secondary focus-ring"
                            data-bs-toggle="offcanvas" data-bs-target="#updateCourseDrawer"
                            (click)="onOpenUpdateDrawer(course)">
                            <i class="fa-solid fa-pen-to-square fs-6"></i>
                        </button>

                        <!-- Remove Action Button -->
                        <!-- <button type="button"
                            class="btn btn-sm btn-outline-danger border-0 p-1.5 rounded-2 d-inline-flex align-items-center justify-content-center focus-ring"
                            style="--bs-focus-ring-color: rgba(var(--bs-danger-rgb), 0.15)" title="Remove Course"
                            [disabled]="apiLoading()" (click)="onRemoveCourse(course.id)">
                            <i class="fa-solid fa-trash-can fs-6"></i>
                        </button> -->
                    </div>
                </td>
            </tr>
            } @empty {
            <tr>
                <td colspan="10" class="py-5 text-body-secondary">
                    <div class="d-flex flex-column align-items-center justify-content-center w-100 text-center">
                        <i class="fa-regular fa-folder-open display-6 mb-3 opacity-50"></i>
                        <span class="tracking-wider">No Course Items found.</span>
                    </div>
                </td>
            </tr>
            }
        </tbody>
    </table>

    <div class="card-footer bg-transparent border-top py-2.5">
        <div class="d-flex justify-content-center">
            <pagination-controls [maxSize]="10" previousLabel="&laquo;" nextLabel="&raquo;" [responsive]="true"
                class="dashboard-pagination" (pageChange)="handlePageChange($event)">
            </pagination-controls>
        </div>
    </div>
</div>

<!-- Floating Mini Card Indicator -->
@if (loading()) {
<div class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
    style="backdrop-filter: blur(4px)">
    <!-- Mini Spinner -->
    <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>

    <!-- Text Badge Layout (Uses your global micro utilities) -->
    <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">Loading...</div>
</div>
}

<div class="modal fade custom-blur-modal" id="addNewCourse" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md">
        <!-- Bind the entire layout to your Reactive Form group -->
        <form [formGroup]="courseForm" (ngSubmit)="onSubmitCourse()"
            class="modal-content shadow-xl border-0 overflow-hidden rounded-4">
            <!-- Modal Header -->
            <div class="modal-header bg-light border-bottom px-4 py-3 align-items-center">
                <h5 class="modal-title fw-bold text-body-emphasis d-flex align-items-center gap-2">
                    <i class="fa-solid fa-circle-plus text-primary fs-5"></i>
                    <span>Add New LMS Course Item</span>
                </h5>
                <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <!-- Modal Body Container -->
            <div class="modal-body px-4 py-4 d-flex flex-column gap-3 bg-body">
                <div>
                    <label
                        class="form-label font-xs fw-extrabold text-body-secondary text-uppercase tracking-wider mb-1.5">
                        Course Name <span class="text-danger">*</span>
                    </label>
                    <input type="text"
                        class="form-control form-control-md shadow-sm border-2 rounded-3 custom-input-field"
                        placeholder="e.g. Email Knowledge Training" formControlName="name" />
                </div>

                <div class="row g-3">
                    <div class="col-md-6">
                        <label
                            class="form-label font-xs fw-extrabold text-body-secondary text-uppercase tracking-wider mb-1.5">
                            Reward Points <span class="text-danger">*</span>
                        </label>
                        <div class="input-group input-group-md shadow-sm border-2 rounded-3 overflow-hidden">
                            <span class="input-group-text bg-light border-0">💎</span>
                            <input type="number" class="form-control border-0 custom-input-field" placeholder="150"
                                formControlName="points" />
                        </div>
                    </div>

                    <div class="col-md-6">
                        <label
                            class="form-label font-xs fw-extrabold text-body-secondary text-uppercase tracking-wider mb-1.5">
                            Catalog Name <span class="text-danger">*</span>
                        </label>

                        <!-- Upgraded from an Input to a Custom Select Dropdown -->
                        <select
                            class="form-select form-select-md shadow-sm border-2 rounded-3 custom-input-field font-sans"
                            formControlName="catalogName">
                            <!-- Disabled Default Prompt Option -->
                            <option value="" disabled selected hidden>-- Select Catalog Group --</option>

                            <!-- Loop through your catalog name list signal -->
                            @for (catalogName of courseCatalogNameList(); track catalogName) {
                            <option [value]="catalogName">{{ catalogName }}</option>
                            } @empty {
                            <option value="" disabled>No active catalogs found...</option>
                            }
                        </select>
                    </div>
                </div>

                <div>
                    <label
                        class="form-label font-xs fw-extrabold text-body-secondary text-uppercase tracking-wider mb-1.5">Redirect
                        Target URL</label>
                    <div class="input-group input-group-md shadow-sm border-2 rounded-3 overflow-hidden">
                        <span class="input-group-text bg-light border-0"><i class="bi bi-link-45deg"></i></span>
                        <input type="url" class="form-control border-0 custom-input-field font-monospace"
                            placeholder="https://lms.com" formControlName="redirectUrl" />
                    </div>
                </div>

                <div>
                    <label
                        class="form-label font-xs fw-extrabold text-body-secondary text-uppercase tracking-wider mb-1.5">
                        Description
                    </label>
                    <textarea class="form-control form-control-md shadow-sm border-2 rounded-3 custom-input-field"
                        rows="3" maxlength="512"
                        placeholder="Provide a comprehensive operational summary of the training course parameters..."
                        formControlName="description">
                    </textarea>

                    <!-- Character Counter Indicator Layout Link Layer -->
                    <div class="form-text text-end small text-body-secondary mt-1">
                        {{ courseForm.get('description')?.value?.length || 0 }}/512 characters
                    </div>
                </div>

            </div>

            <!-- Modal Footer Actions Group Row -->
            <div class="modal-footer bg-light border-top px-4 py-2.5">
                <button type="button" class="btn btn-sm btn-secondary opacity-75 shadow-sm px-3 py-1.5 fw-medium"
                    data-bs-dismiss="modal">
                    Close
                </button>

                <button type="submit"
                    class="btn btn-sm btn-primary px-4 py-2 shadow-sm fw-bold d-inline-flex align-items-center gap-2 rounded-3 micro-action-btn hover-scale"
                    [disabled]="courseForm.invalid || apiLoading()">
                    @if (apiLoading()) {
                    <span class="spinner-border spinner-border-sm flex-shrink-0" role="status"></span>
                    <span>Creating...</span>
                    } @else {
                    <span>Submit<i class="fa-solid fa-paper-plane font-xs"></i></span>
                    }
                </button>
            </div>
        </form>
    </div>
</div>

<!-- Beautiful Right-Sliding Update Panel -->
<div class="offcanvas offcanvas-end bg-body-tertiary border-start border-secondary-subtle shadow" tabindex="-1"
    id="updateCourseDrawer" aria-labelledby="updateCourseDrawerLabel">
    <!-- Drawer Header -->
    <div class="offcanvas-header border-bottom border-secondary-subtle bg-body p-3">
        <div class="d-flex align-items-center gap-2" id="updateCourseDrawerLabel">
            <div class="p-2 bg-primary-subtle text-primary rounded-2 fs-5 d-flex align-items-center justify-content-center"
                style="width: 38px; height: 38px">
                <i class="fa-solid fa-pen-to-square"></i>
            </div>
            <div>
                <h6 class="offcanvas-title fw-bold text-body mb-0">Update Course Details</h6>
                <small class="text-body-secondary" style="font-size: 0.75rem">Modify item parameters instantly</small>
            </div>
        </div>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="offcanvas" aria-label="Close"
            id="closeDrawerButton"></button>
    </div>

    <!-- Drawer Body (Form Content Layout) -->
    <div class="offcanvas-body p-4">
        <form [formGroup]="updateForm" (ngSubmit)="submitUpdateQuery()">
            <!-- Hidden Tracked ID Field Indicator -->
            <input type="hidden" formControlName="courseItemId" />

            <!-- Course Name Input -->
            <div class="mb-3">
                <label for="editCourseName" class="form-label text-body-secondary small fw-medium mb-1.5">
                    Course Name <span class="text-danger">*</span>
                </label>
                <div class="position-relative">
                    <div
                        class="position-absolute top-50 start-0 translate-middle-y ps-3 text-body-secondary opacity-75 pointer-events-none z-3 small">
                        <i class="fa-solid fa-graduation-cap"></i>
                    </div>
                    <input type="text" id="editCourseName"
                        class="form-control ps-5 py-2.5 bg-body text-body-emphasis border-secondary-subtle shadow-sm focus-ring"
                        style="--bs-focus-ring-color: rgba(var(--bs-primary-rgb), 0.25)" formControlName="name"
                        placeholder="Enter course name" autocomplete="off" />
                </div>
            </div>

            <!-- Points Input Weight -->
            <div class="mb-3">
                <label for="editCoursePoints" class="form-label text-body-secondary small fw-medium mb-1.5">
                    Points Configuration <span class="text-danger">*</span>
                </label>
                <div class="position-relative">
                    <div
                        class="position-absolute top-50 start-0 translate-middle-y ps-3 text-body-secondary opacity-75 pointer-events-none z-3 small">
                        <i class="fa-solid fa-award"></i>
                    </div>
                    <!-- Removed [disabled]="true" and focus-ring. Changed bg-body to bg-body-secondary -->
                    <input type="number" id="editCoursePoints" min="1"
                        class="form-control ps-5 py-2.5 bg-body-secondary text-body-emphasis border-secondary-subtle shadow-sm"
                        formControlName="points" placeholder="Enter point value weight" />
                </div>
            </div>


            <!-- Redirect URL Link Input -->
            <div class="mb-3">
                <label for="editRedirectUrl" class="form-label text-body-secondary small fw-medium mb-1.5">Redirect URL
                    Link</label>
                <div class="position-relative">
                    <div
                        class="position-absolute top-50 start-0 translate-middle-y ps-3 text-body-secondary opacity-75 pointer-events-none z-3 small">
                        <i class="fa-solid fa-link"></i>
                    </div>
                    <input type="url" id="editRedirectUrl"
                        class="form-control ps-5 py-2.5 bg-body text-body-emphasis border-secondary-subtle shadow-sm focus-ring"
                        style="--bs-focus-ring-color: rgba(var(--bs-primary-rgb), 0.25)" formControlName="redirectUrl"
                        placeholder="https://example.com" autocomplete="off" />
                </div>
            </div>

            <!-- Course Summary Description Field -->
            <div class="mb-4">
                <label for="editDescription" class="form-label text-body-secondary small fw-medium mb-1.5">
                    Course Description Summary
                </label>
                <div class="position-relative">
                    <!-- Added maxlength="512" directly to the textarea -->
                    <textarea id="editDescription" rows="4"
                        class="form-control py-2.5 bg-body text-body-emphasis border-secondary-subtle shadow-sm focus-ring"
                        style="--bs-focus-ring-color: rgba(var(--bs-primary-rgb), 0.25)" formControlName="description"
                        maxlength="512" placeholder="Write comprehensive item overview notes here...">
                    </textarea>
                </div>
                <!-- Real-time Character Counter -->
                <div class="form-text text-end small text-body-secondary mt-1">
                    {{ updateForm.get('description')?.value?.length || 0 }}/512 characters
                </div>
            </div>


            <!-- Sticky Action Panel Button Controls Footer -->
            <div class="d-grid gap-2 pt-2">
                <button type="submit"
                    class="btn btn-primary py-2.5 fw-semibold shadow-sm d-flex align-items-center justify-content-center gap-2"
                    [disabled]="updateForm.invalid || apiLoading()">
                    @if (apiLoading()) {
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span>Saving Updates...</span>
                    } @else {
                    <i class="fa-solid fa-floppy-disk"></i>
                    <span>Save Course Parameters</span>
                    }
                </button>
                <button type="button"
                    class="btn btn-outline-secondary border-secondary-subtle py-2.5 text-body-secondary"
                    data-bs-dismiss="offcanvas" [disabled]="apiLoading()">
                    Cancel changes
                </button>
            </div>
        </form>
    </div>
</div>